<template>
  <el-card :body-style="{ padding: '20px', height: '100%' }" class="h-full">
    <div class="drawlisttop">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        clearable
        :placeholder="$t('enterNameOrCode')"
        class="topInput mr-10px ml-10px"
        size="small"
        v-model="standardName"
      ></el-input>
      <el-button @click="initList" size="small" type="primary">{{ $t('search') }}</el-button>
      <!-- <el-popover class="r" placement="bottom-start" width="200" trigger="click">
        <el-checkbox-group v-model="checkList" @change="changeChecked" :max="1">
          <div class="w-100 l p-5" v-for="item in sortList" :key="item.id">
            <el-checkbox class="l" :label="item.id">{{ item.name }}</el-checkbox>
            <span
              class="fz-14 r cur-pointer"
              :class="{
                'el-icon-sort': !item.sort,
                'el-icon-sort-down': item.sort === 'desc',
                'el-icon-sort-up': item.sort === 'asc',
              }"
              @click="changeSortType(item)"
            ></span>
          </div>
        </el-checkbox-group>
        <el-button
          icon="el-icon-more"
          slot="reference"
          size="small"
          style="transform: rotate(90deg); padding: 9px 7px 9px 5px"
        ></el-button>
      </el-popover> -->
    </div>
    <div class="bigDrawContainer mt-20px">
      <div class="drawContainer">
        <div class="drawDiv newdraw" @click="addNewDraw" v-if="$hasAccess('create')">
          <i class="el-icon-plus divicon"></i>
          <p>{{ $t('createDrawing') }}</p>
        </div>
        <div v-for="item in drawList" :key="item.id" class="drawDiv">
          <img
            src="../../../../../public/images/drawing.png"
            alt
            class="footimg"
            @click="goCurrDraw(item)"
          />
          <div class="LitFoot">
            <div class="botLeft">{{ item.name }}</div>
            <div class="botRight">
              <div @click="editCurrDraw(item)" v-if="$hasAccess('update')">
                <i class="el-icon-edit"></i>
              </div>
              <div @click="deleteDraw(item)" v-if="$hasAccess('delete')">
                <i class="el-icon-circle-close"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="`${$t('createDrawing')}`"
      :visible.sync="addNewDrawVisible"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form
        :model="newDrawInfo.model"
        class="demo-form-inline"
        id="addnewdrawform"
        label-width="150px"
        :rules="currentLang === 'zh' ? addnewdrawrule : addnewdrawEnRule"
        ref="addNewDrawForm"
      >
        <el-form-item :label="`${$t('code')}`" prop="code" class="w-full">
          <el-input
            clearable
            size="small"
            v-model="newDrawInfo.model.code"
            :placeholder="`${$t('pleaseEnterCode')}`"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('name')}`" prop="name" class="w-full">
          <el-input
            v-model="newDrawInfo.model.name"
            size="small"
            :placeholder="`${$t('pleaseEnterTheName')}`"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('seqNo')}`" class="w-full">
          <el-input-number
            clearable
            :controls="false"
            size="small"
            v-model="newDrawInfo.model.seqNo"
            :placeholder="`${$t('pleaseEnterTheSeqNo')}`"
            class="!w-440px"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="`${$t('remark')}`" class="w-full">
          <el-input
            clearable
            type="textarea"
            size="small"
            v-model="newDrawInfo.model.remark"
            :placeholder="`${$t('pleaseEnterTheRemark')}`"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="addNewDrawConfirm" :loading="isLoading">{{
          $t('save')
        }}</el-button>
        <el-button @click="addNewDrawVisible = false">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${$t('editDrawing')}`"
      :visible.sync="editDrawVisible"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form
        :model="editDrawInfo"
        class="demo-form-inline"
        label-width="150px"
        ref="editDrawForm"
        :rules="currentLang === 'zh' ? addnewdrawrule : addnewdrawEnRule"
      >
        <el-form-item :label="`${$t('code')}`" prop="code">
          <el-input
            v-model="editDrawInfo.code"
            :placeholder="`${$t('pleaseEnterCode')}`"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('name')}`" prop="name">
          <el-input
            v-model="editDrawInfo.name"
            :placeholder="`${$t('pleaseEnterTheName')}`"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('seqNo')}`">
          <el-input
            v-model="editDrawInfo.seqNo"
            :placeholder="`${$t('pleaseEnterTheSeqNo')}`"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('remark')}`">
          <el-input
            type="textarea"
            v-model="editDrawInfo.remark"
            :placeholder="`${$t('pleaseEnterTheRemark')}`"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button @click="cancelEdit" size="small" class="iconfont icon-close">
          {{ $t('cancel') }}
        </el-button>
        <el-button type="primary" @click="saveEdit" size="small" class="iconfont icon-save">
          {{ $t('save') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="`${$t('whetherDelete')}`"
      :visible.sync="deleteDialogShow"
      class="small-dialog"
    >
      <p>{{ $t('whetherDelete') }}{{ this.currDraw.name }}</p>
      <div slot="footer" class="dialog-footer tc">
        <el-button @click="cancelDelete" size="small" class="iconfont icon-close">
          {{ $t('cancel') }}
        </el-button>
        <el-button type="primary" size="small" @click="deleteConfirm" class="iconfont icon-save">
          {{ $t('save') }}
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import StdDrawingService from '@/services/common/StdDrawingService'
import selectStandardId from '../../components/selectStandardId'

export default {
  components: {
    selectStandardId,
  },
  data() {
    return {
      isLoading: false,
      sortList: [
        {
          id: 1,
          name: '序号',
          sort: 'desc',
          sortField: 'seqNo',
        },
        {
          id: 2,
          name: '名称',
          sort: '',
          sortField: 'name',
        },
        {
          id: 3,
          name: '代码',
          sort: '',
          sortField: 'code',
        },
      ],
      checkList: [1],
      addnewdrawrule: {
        name: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        code: [
          {
            required: true,
            trigger: 'blur',
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
          },
        ],
      },
      addnewdrawEnRule: {
        name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'blur' }],
        code: [
          {
            required: true,
            trigger: 'blur',
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
          },
        ],
      },
      standard: /^(?!(\d)+$)[\w]+$/,
      standardName: '',
      currStandard: localStorage.getItem('standardId'),
      currDraw: {},
      currDrawId: [],
      deleteDialogShow: false,
      editDrawVisible: false,
      addNewDrawVisible: false,
      drawList: [],
      drawListCopy: [], // 除排序外无其他用途
      editDrawInfo: {
        id: '',
        code: '',
        name: '',
        seqNo: '',
        remark: '',
      },
      newDrawInfo: {
        model: {
          name: '',
          code: '',
          seqNo: '',
          remark: '',
          standardId: this.currStandard,
        },
        updateColumns: [],
        noRepeatNames: '',
      },
      pageData: {
        pageno: '1',
        pagesize: '10',
        name: '',
        standard_id: this.currStandard,
      },
    }
  },
  computed: {
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  watch: {
    currStandard: {
      handler(value) {
        this.pageData.standard_id = value
        this.initList()
      },
    },
    checkList: {
      deep: true,
      handler(newVal) {
        this.sortData(newVal)
      },
    },
  },
  async created() {
    if (this.$route.query.id) {
      this.currStandard = this.$route.query.id
    }
    if (this.currStandard) {
      this.initList()
    }
  },
  activated() {
    this.currStandard = localStorage.getItem('standardId')
  },
  methods: {
    updateStandardId(val) {
      this.currStandard = val
    },
    sortData(data) {
      if (_.isEmpty(data)) {
        this.drawList = _.cloneDeep(this.drawListCopy)
      } else {
        const item = _.find(this.sortList, { id: this.checkList[0] })
        if (item.sort) {
          // 数字排序
          if (item.sortField === 'seqNo') {
            this.drawList.sort((a, b) => {
              if (item.sort === 'asc') {
                return a[item.sortField] - b[item.sortField]
              }
              return b[item.sortField] - a[item.sortField]
            })
          } else {
            // 中英文混合排序，升序为字母在前，中文在后。降序为中文在前，字母在后
            this.drawList.sort((a, b) => {
              const reg = /[a-zA-Z0-9]/
              const x = _.lowerCase(a[item.sortField])
              const y = _.lowerCase(b[item.sortField])
              if (reg.test(x) || reg.test(y)) {
                if (item.sort === 'asc') {
                  if (x > y) {
                    return 1
                  }
                  if (x < y) {
                    return -1
                  }
                  return 0
                }
                if (x > y) {
                  return -1
                }
                if (x < y) {
                  return 1
                }
                return 0
              }
              return x.localeCompare(y)
            })
          }
        } else {
          this.drawList = _.cloneDeep(this.drawListCopy)
        }
      }
    },
    // changeChecked(val) {
    //   console.log(val)
    // },
    /**
     * 切换升降序
     * asc 升序
     * desc 降序
     */
    changeSortType(item) {
      if (this.checkList[0] === item.id) {
        if (!item.sort) {
          item.sort = 'asc'
        } else if (item.sort === 'asc') {
          item.sort = 'desc'
        } else if (item.sort === 'desc') {
          item.sort = ''
        }
        this.sortData(this.checkList)
      }
    },
    async initList() {
      const query = {
        // name: {
        //   $text: this.standardName,
        // },
        keyword: this.standardName,
        standard_id: this.currStandard,
      }
      const res = await StdDrawingService.askdrawlist(query)
      if (res && res.code === 0 && res.data) {
        this.drawList = res.data
        this.drawListCopy = _.cloneDeep(res.data)
        this.sortData(this.checkList)
      } else {
        this.$message.error(this.$t('resultError'))
      }
    },
    goCurrDraw(item) {
      let path = ''
      path = './data-model-detail'
      this.$router.push({
        path,
        query: {
          standard_id: this.currStandard,
          id: item.id,
        },
      })
    },
    addNewDraw() {
      this.newDrawInfo.model = {
        name: '',
        code: '',
        seqNo: '',
        remark: '',
        standardId: this.currStandard,
      }
      this.addNewDrawVisible = true
      if (this.drawList.length === 0) {
        this.newDrawInfo.model.seqNo = 1
      } else {
        const seqArr = []
        _.forEach(this.drawList, (value) => {
          seqArr.push(value.seqNo)
        })
        seqArr.sort((a, b) => {
          return b - a
        })
        this.newDrawInfo.model.seqNo = seqArr[0] + 1
      }
      if (this.$refs.addNewDrawForm) {
        this.$refs.addNewDrawForm.clearValidate()
      }
    },
    cancelEdit() {
      this.editDrawVisible = false
      this.initList()
    },
    editCurrDraw(item) {
      this.editDrawInfo = _.cloneDeep(item)
      this.editDrawVisible = true
    },

    async addNewDrawConfirm() {
      this.$refs.addNewDrawForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error(this.$t('pleaseEnterCorrectCode'))
          return false
        }
        this.isLoading = true
        this.newDrawInfo.model.standardId = this.currStandard
        const res = await StdDrawingService.addnewdraw(this.newDrawInfo)
        if (res && res.code === 0) {
          this.addNewDrawVisible = false
          this.$message.success(res.msg)
          this.initList()
        }
        this.isLoading = false
        return true // 为解决eslint报错
      })
    },
    async saveEdit() {
      this.$refs.editDrawForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        const query = {
          model: {
            id: this.editDrawInfo.id,
            name: this.editDrawInfo.name,
            code: this.editDrawInfo.code,
            seqNo: this.editDrawInfo.seqNo,
            remark: this.editDrawInfo.remark,
            standardId: this.currStandard,
          },
          updateColumns: [],
          noRepeatNames: '',
        }
        const res = await StdDrawingService.editdraw(query)
        if (res.code === 0) {
          this.editDrawVisible = false
          this.$message.success(this.$t('SuccessfullyModified'))
          this.initList()
        }
        return true // 为解决eslint报错
      })
    },
    cancelDelete() {
      this.currDraw = {}
      this.currDrawId = []
      this.deleteDialogShow = false
    },
    deleteDraw(item) {
      this.currDraw = item
      this.currDrawId.push(item.id)
      this.$confirm(
        `${this.$t('deleteDrawing')}(${this.currDraw.name})，${this.$t('whetherContinue')}?`,
        this.$t('tip'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          this.deleteConfirm()
          this.$message.success(this.$t('deleteSuccess'))
        })
        .catch(() => {
          this.$message.info(this.$t('cancelDelete'))
        })
    },
    async deleteConfirm() {
      const query = this.currDrawId
      const res = await StdDrawingService.deletedraw(query)
      this.deleteDialogShow = false
      this.initList()
    },
    standardChanged() {
      this.initList()
    },
  },
}
</script>

<style type="text/css" lang="scss">

.bigDrawContainer {
  height: calc(100% - 57px);
  width: 100%;
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: center;
  // align-items: center;
}
.drawContainer {
  width: 100%;
  // height: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
}

.drawDiv {
  border: 2px rgb(216, 215, 215) solid;
  width: 15rem;
  height: 15rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

.newdraw {
  font-size: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px rgb(134, 133, 133) dashed;
}
.newdraw p {
  margin-top: 20px;
  font-size: 10px;
}
.divicon {
  cursor: pointer;
  display: block;
  margin-top: 30px;
}
.LitFoot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--mainBgColor);
  padding-right: 1em;
  padding-left: 1em;
  height: 12.5%;
}
.LitFoot > div {
  height: 70%;
}
.footimg {
  width: 100%;
  height: 85%;
}
.botRight {
  display: flex;
}
.botRight > div {
  font-size: 5px;
  cursor: pointer;
  color: white;
  width: 20px;
  text-align: center;
  border-radius: 5px;
}
.botRight > div:nth-child(1) {
  margin-right: 10px;
  background-color: rgba(77, 77, 238, 0.473);
}
.botRight > div:nth-child(2) {
  background-color: rgba(241, 6, 17, 0.473);
}
.addnewdrawinput {
  width: 60% !important;
}
#addnewdrawform {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.botLeft {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.topselect {
  width: 20%;
  margin-left: 0.5%;
}
.drawlisttop .topInput {
  width: 13%;
}
.inputnumwidth {
  width: 100% !important;
}
.el-input-number.is-without-controls .el-input__inner {
  text-align: left !important;
}

</style>
